import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ post }) => {

    if (!post || post?.show_footer === false) return null;

    return (
        <footer className="c-footer c-page__block">
            <div className="l-grid">
                <div className="l-grid__col">
                    {post.ftr_contact_info && post.show_footer === true &&(
                        <div 
                            className="c-footer__pos-statement scope-text scope-text--footer" 
                            dangerouslySetInnerHTML={{ __html: post.ftr_contact_info }} 
                        />
                    )}
                    {post.ftr_min_contact_info && post.show_footer === 'partial' &&(
                        <div 
                            className="c-footer__pos-statement scope-text scope-text--footer" 
                            dangerouslySetInnerHTML={{ __html: post.ftr_min_contact_info }} 
                        />
                    )}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
